<script>
import MethodButtonBase from './MethodButtonBase';
export default {
  name: 'OtpButton',
  components: {
    MethodButtonBase,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      {{ $t('email-sms') }}
    </template>
  </MethodButtonBase>
</template>
